$.ajaxSetup({
  beforeSend: function (xhr) { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
  success: function(data, status, response) {
    const newCsrf = response.getResponseHeader('X-CSRF-TOKEN')
    if (newCsrf) {
      $('meta[name="csrf-token"]').attr('content', newCsrf);
    }
  },
});